import GeoLocationStorage from './geolocation-storage';

export default class GeoLocationLocalStorage implements GeoLocationStorage {
    getItem(key) {
        return localStorage.getItem(key);
    }

    setItem(key, value) {
        localStorage.setItem(key, value);
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }
}
